<!-- <h1>Project Name {{projectName}}</h1> -->
<!-- <h1>{{projectName()}}</h1> -->
<p-toast [life]="3000" [baseZIndex]="50000" [preventOpenDuplicates]="true"></p-toast>
@if (isLoading()) {
<div class="loading-overlay">
    <div class="loading-content flex flex-column align-items-center gap-3">
        <i class="pi pi-spin pi-spinner text-yellow-500" style="font-size: 3rem"></i>
        <span class="text-white font-medium text-lg">{{ loadingMessage() }}</span>
    </div>
</div>
}
<router-outlet></router-outlet>